module.exports = __webpack_public_path__ + "img/circle.c551a785.png";